import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { getSubtitle } from "./BillingCellSubtitle.utils";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetBillingCellSubtitleTID = parentTestId => getTestIds(parentTestId);
export const BillingCellSubtitle = _ref => {
  let {
    service,
    testid
  } = _ref;
  const testIds = useMemo(() => GetBillingCellSubtitleTID(testid), [testid]);
  const subtitle = useMemo(() => getSubtitle(service), [service]);
  if (!subtitle) return null;
  return /*#__PURE__*/_jsx(Typography, {
    "data-testid": testIds.BillingCellSubtitleTestIds.Text(),
    variant: "paragraph2",
    skin: "secondary",
    ellipsis: true,
    children: subtitle
  });
};